<template>
  <div class="ac-service-resolved ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-b gap-16">
        <button
          class="ac-close-button"
          type="button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="Close"
            class="ac-close"
          />
        </button>
        <div class="ac-header">
          Invoice
        </div>
      </div>
    </div>

    <div class="ac-body-container">
      <div class="ac-contract-container mt-5">
        <iframe
          v-if="pdfFile"
          :src="pdfFile"
          class="pdf-view"
          frameborder="0"
        />

        <div class="margin-bottom-4">
          <form
            class="dropbox-form"
            enctype="multipart/form-data"
          >
            <input
              ref="pdfRef"
              type="file"
              class="pdf-input"
              accept="application/pdf"
              @change="onLoad"
            />
          </form>

          <div v-if="errorObj.pdfDocErr" class="error-text">
            {{ errorObj.pdfDocErr }}
          </div>
        </div>
      </div>
    </div>

    <div class="ac-footer-start-container">
      <button
        class="sac__button bg-red"
        type="button"
        @click="clear"
      >
        <img
          v-if="deleting"
          class="ac-processing"
          src="@shared/assets/img/general/loading-white.svg"
          alt="Processing"
        />
        <span v-else>Delete</span>
      </button>
      <button
        class="sac__button bg-transparent"
        type="button"
        :disabled="updating"
        @click="replaceInvoice"
      >
        <img
          v-if="updating"
          class="ac-processing"
          src="@shared/assets/img/general/loading.svg"
          alt="Processing"
        />
        <span v-else>Replace</span>
      </button>
    </div>
  </div>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'AddInvoice',
  mixins: [serviceMixin],
  props: {
    update: Function,
  },
  data() {
    return {
      pdf: null,
      pdfFile: null,
      errorObj: {},
      updating: false,
      deleting: false,
      pdfDoc: null,
      objectUrl: null,
    };
  },
  watch: {
    pdfDoc(newVal) {
      if (!newVal) {
        this.pdf = '';
        this.pdfFile = null;
        this.revokeObjectUrl();
      }
    },
  },
  mounted() {
    const { invoiceUrl } = this.serviceInfo;
    if (invoiceUrl) {
      this.loadingPdf(invoiceUrl);
    } else {
      this.$nextTick(() => {
        this.selectPdf();
      });
    }
  },
  beforeDestroy() {
    this.revokeObjectUrl();
  },
  methods: {
    handleChange(field, value) {
      this[field] = value;
    },
    onLoad(e) {
      const file = e.target.files[0];
      if (file) {
        if (file.type === 'application/pdf') {
          this.pdf = file.name;
          this.handleChange('pdfDoc', file);
          this.errorObj.pdfDocErr = '';

          this.revokeObjectUrl();

          this.objectUrl = URL.createObjectURL(file);
          this.pdfFile = this.objectUrl;
          this.updateInvoice();
        } else {
          this.errorObj.pdfDocErr = 'Please select a valid PDF file.';
        }
      }
    },
    replaceInvoice() {
      this.selectPdf();
    },
    selectPdf() {
      this.$refs.pdfRef.click();
    },
    async clear() {
      this.deleting = true;
      try {
        await this.$store.dispatch('removeServiceJobInvoice');
        await this.toggleActionModal(false);
      } catch (error) {
        this.errorObj.pdfDocErr = 'Failed to delete invoice. Please try again.';
      } finally {
        this.deleting = false;
      }
    },
    revokeObjectUrl() {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }
    },
    async loadingPdf(pdfUrl) {
      try {
        this.pdfFile = await this.$store.dispatch('getInvoiceResponse', pdfUrl);
      } catch (error) {
        this.errorObj.pdfDocErr = 'Failed to load the invoice PDF.';
      }
    },
    async updateInvoice() {
      if (!this.pdfDoc) {
        this.errorObj.pdfDocErr = 'Invoice Document is required.';
        return;
      }

      this.updating = true;
      const formData = new FormData();
      formData.append('pdfDoc', this.pdfDoc);
      formData.append('jobId', this.serviceInfo.jobId);

      try {
        const data = await this.$store.dispatch('setInvoice', formData);
        await this.loadingPdf(data);
        const updatedServiceJob = {
          ...this.serviceInfo,
          actionStatus: this.serviceInfo.serviceStatus,
          invoiceUrl: data,
        };
        const changes = [{
          field: 'serviceInfo',
          value: updatedServiceJob,
        }];
        this.$store.dispatch('changeServiceValues', changes);
      } catch (error) {
        this.errorObj.pdfDocErr = 'Failed to update invoice. Please try again.';
      } finally {
        this.updating = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ac-contract-container {

  &:not(:last-child) {
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-bottom: 2px solid $N20;
  }

  .pdf-input {
    display: none;
  }

  .pdf-view {
    height: 400px;
    width: 100%;
  }

  .i-row-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;

    .file-name-container {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 500;
      color: $NBLUE100;

      .clear-icon {
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: darken(#FF5B52, 10%);
        }
      }
    }

    .prompt-container {
      display: flex;
      align-items: center;
      gap: 10px;
      color: $NBLUE100;

      .i-form-button {
        padding: 0 16px;
        height: 40px;
        border: none;
        border-radius: 6px;
        background-color: $NBLUE100;
        font-weight: 600;
        color: $WHITE;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
          background-color: darken($NBLUE100, 10%);
        }
      }
    }
  }

  .error-text {
    color: $TOMATO100;
    font-weight: 500;
    font-size: 14px;
    margin-top: 5px;
  }
}
</style>
